interface Env {
  FLOWISE_TOKEN: string;
}

export const env: Env = {
  FLOWISE_TOKEN: process.env.REACT_APP_FLOWISE_TOKEN || '',
};
